var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row roomy position-relative container-scene" },
    [
      _c(
        "div",
        {
          staticClass:
            "content column-12 laptop:column-6 padding-top-6xl padding-bottom-3xl display-flex flex-column flex-align-center",
        },
        [
          _c(
            "div",
            { staticClass: "margin-bottom-xl" },
            [
              _c("h2", { staticClass: "text-capitalize" }, [
                _c("i", {
                  class: [
                    `fa-${_vm.selectedFamily} ${_vm.getStyleTag(
                      _vm.selectedStyle
                    )} fa-${_vm.categoryIcon} fa-lg margin-right-3xs`,
                  ],
                }),
                _vm._v("\n        " + _vm._s(_vm.category) + " Icons\n      "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "margin-y-xl" }, [
                _vm._v(_vm._s(_vm.description)),
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass:
                      "tag white rounded margin-right-md margin-bottom-md",
                    staticStyle: { "--tag-background": "var(--white)" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.totalIconCount) +
                        " Icons\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.newIconCount > 0
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "tag white rounded margin-right-md margin-bottom-md",
                        staticStyle: { "--tag-background": "var(--white)" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.newIconCount) +
                            " New\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.freeIconCount > 0
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "tag white rounded margin-right-md margin-bottom-md",
                        staticStyle: { "--tag-background": "var(--white)" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.freeIconCount) +
                            " Free\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("wa-carbon-ad", { staticClass: "margin-top-xl" }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "scene position-absolute" }, [
        _vm.state
          ? _c(
              "div",
              { staticClass: "display-none laptop:display-block" },
              _vm._l(_vm.iconList.icons, function (icon) {
                return _c(
                  "div",
                  {
                    key: icon.id,
                    class: `${icon.extraClass} display-flex flex-items-center flex-content-center padding-sm position-absolute with-border-radius`,
                    staticStyle: { "aspect-ratio": "1 / 1" },
                    style: icon.cssStyle,
                  },
                  [
                    _c("i", {
                      class: `fa-fw ${_vm.getStyleTag(icon.style)} fa-${
                        icon.icon
                      } ${icon.extraIconClass}`,
                      style: icon.cssIconStyle,
                    }),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }